import React from 'react'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'
import { getLayout } from '../src/layouts/WhiteBgLayout'
import { GetServerSideProps } from 'next'
import { ConsumerPage } from '../src/model'

import { CreatePasswordPage as CreatePasswordPageEntry } from '../src/page/CreatePassword/CreatePassword'

const I18N_NAMESPACE = ['common', 'createPassword', 'password']

const CreatePasswordPage: ConsumerPage = (props) => {
  return <CreatePasswordPageEntry {...props} />
}

CreatePasswordPage.getLayout = getLayout({ isHideClose: true, fullscreenWhite: true })

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)

export default CreatePasswordPage
